import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '../ui/table.tsx';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar.tsx';
import { Button } from '../ui/button.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown.tsx';
import { MoreHorizontal } from 'lucide-react';
// import { useState } from 'react';
import { Badge } from '../ui/badge.tsx';

const StaffTeamTableCard = ({ staff, handleEdit, handleDelete }) => {
  // const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);

  const navigate = useNavigate();

  const handleViewDetails = (staffId) => {
    navigate(`/team/profile/${staffId}`);
  };

  // const handleDelete = (member, e) => {
  //   // Todo: Handle delete action for staff
  // };

  const rowActions = (member) => (
    <DropdownMenu>
      <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleViewDetails(member.staffId);
          }}
        >
          View details
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleEdit(member, e)}>
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          className="text-red-600"
          onClick={(e) => handleDelete(member, e)}
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  const formatDateNative = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <TableRow
        key={staff.id}
        className="cursor-pointer"
        onClick={() => handleViewDetails(staff.staffId)}
      >
        <TableCell>
          <div className="flex gap-x-2 items-center">
            <Avatar className="h-9 w-9">
              <AvatarImage
                src={staff.photoUrl || ''}
                alt={`${staff.firstName} ${staff.lastName}`}
              />
              <AvatarFallback>
                {staff.firstName[0]}
                {staff.lastName[0]}
              </AvatarFallback>
            </Avatar>
            <div>
              <p className="font-medium">
                {staff.firstName} {staff.lastName}
              </p>
              <p className="text-sm text-gray-500">{staff.email}</p>
            </div>
          </div>
        </TableCell>
        <TableCell>{staff.department.name}</TableCell>
        <TableCell>{`${
          staff.designation ? staff.designation : 'N/A'
        }`}</TableCell>
        <TableCell>{formatDateNative(staff.startDate)}</TableCell>
        <TableCell>
          <Badge
            variant="secondary"
            className="text-xs bg-purple-600/10 text-purple-600 border-purple-600/20 capitalize"
          >
            {staff.role.name}
          </Badge>
        </TableCell>
        <TableCell>
          <Badge
            variant={staff.verified ? 'default' : 'secondary'}
            className={
              staff.verified
                ? 'bg-green-500/10 text-green-600 border-green-500/20'
                : 'bg-gray-500/10 text-gray-600 border-gray-500/20'
            }
          >
            {staff.verified ? 'Active' : 'Inactive'}
          </Badge>
        </TableCell>
        <TableCell>{rowActions(staff)}</TableCell>
      </TableRow>
    </>
  );
};

export default StaffTeamTableCard;
